import { useState } from 'react';

// graphql
import { PageInfo, usePlt_TerminalLossTransfersQuery, useConfirmTerminalLossTransferMutation } from '@/generated/graphql';

// interfaces
import { ITerminalLossTransferQueryVariable, ITerminalLossTransferTable, mapGQLTerminalLossTransfer } from '@/shared/interfaces';

// components
import { TableTerminalLossTransfers } from './table';
import { IModalConfirmationDetails, ConfirmationModal } from '@/components/modal/confirmation';

interface IProps {
  refetch: () => void;
}

export const TerminalLossTransfer = ({ refetch }: IProps) => {
  const [confirmTerminalLossTransfer] = useConfirmTerminalLossTransferMutation();

  const [terminalLossTransfers, setTerminalLossTransfers] = useState<ITerminalLossTransferTable[]>([]);
  const [terminalLossTransfer, setTerminalLossTransfer] = useState<ITerminalLossTransferTable | undefined>();

  const [confirmationModal, setConfirmationModal] = useState<IModalConfirmationDetails>({
    isOpen: false,
    title: 'Are you sure ?',
    messages: ['You want to confirm this transaction'],
  });

  const [terminalLossTransfersQueryVariable, setTerminalLossTransfersQueryVariable] = useState<ITerminalLossTransferQueryVariable>({
    first: 25,
  });

  const [terminalLossTransfersPageInfo, setTerminalLossTransfersPageInfo] = useState<PageInfo>();
  const [terminalLossTransfersTotalCount, setTerminalLossTransfersTotalCount] = useState<number>(0);

  const terminalLossTransfersQuery = usePlt_TerminalLossTransfersQuery({
    variables: terminalLossTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalLossTransfers.nodes.map((x) => mapGQLTerminalLossTransfer(x));

      const mappedTableData: ITerminalLossTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setTerminalLossTransfers(mappedTableData);
        setTerminalLossTransfersPageInfo(data.terminalLossTransfers.pageInfo);
        setTerminalLossTransfersTotalCount(data.terminalLossTransfers.totalCount);
      }, 100);
    },
  });

  const transactionAction = (actionType: string, data: ITerminalLossTransferTable) => {
    switch (actionType) {
      case 'confirm':
        setTerminalLossTransfer(data);
        setConfirmationModal((prev) => ({ ...prev, isOpen: true }));
        break;
      default:
        break;
    }
  };

  const confirmTransaction = () => {
    if (terminalLossTransfer) {
      setConfirmationModal((prev) => ({ ...prev, isOpen: false }));
      confirmTerminalLossTransfer({
        variables: {
          confirmTerminalLossTransferId: terminalLossTransfer.id,
        },
        onCompleted: () => {
          terminalLossTransfersQuery.refetch();
          refetch();
        },
      });
    }
  };

  return (
    <>
      <TableTerminalLossTransfers
        rows={terminalLossTransfers}
        setTerminalLossTransferQueryVariable={setTerminalLossTransfersQueryVariable}
        terminalLossTransferQueryVariable={terminalLossTransfersQueryVariable}
        totalCount={terminalLossTransfersTotalCount}
        pageInfo={terminalLossTransfersPageInfo}
        getTerminalLossTransferLoading={terminalLossTransfersQuery.loading}
        transactionAction={transactionAction}
      />
      <ConfirmationModal
        modalDetails={confirmationModal}
        setModalDetails={setConfirmationModal}
        confirm={confirmTransaction}
        confirmText={'confirm'}
      />
    </>
  );
};
